import { createHash, createHmac } from "crypto";
import { loadToken } from "../auth";

export { mapErrorCode } from "./mapErrorCode";

export function generateNewSignature(payload = {}, date) {
  const token = loadToken();
  const sha = createHash("sha256").update(JSON.stringify(payload)).digest("hex");
  const hmac = createHmac("sha512", process.env.BIG_FLIP_SECRET_SIGNATURE);
  const strignToSign = `POST:/dis-transaction-service/dashboard/v1/bank-account/bank-account-inquiry:${token}:${sha}:${date}`;
  const signed = hmac.update(strignToSign).digest("base64");
  return signed;
}
